import axios from "axios";
import { toast } from "vue-sonner";
import { API } from "~/constants/endpoints";

export const http = axios.create({
  baseURL: API.BASE_URL,
});

export function createInterceptor(token: string | null) {
  http.interceptors.request.clear();
  http.interceptors.response.clear();

  if (!token) return null;

  http.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  http.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.config.url.includes("pje-customer-processes")) {
        toast.error(error.response?.data.context.error_message || "Erro ao buscar processos no PJE.");
      }

      if (error.response?.status === 401) {
        const authStore = useAuthStore();
        const router = useRouter();
        authStore.signout();
        router.push("/signin");
        localStorage.setItem("signOutMessage", "Sua sessão expirou. Faça login novamente.");
      }
      return Promise.reject(error);
    },
  );
}
